// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-chart-title {
  color: #2d2d2d;
  font-size: 16px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.5px;
}

.success-chart-card.MuiPaper-root.MuiCard-root {
  height: auto;
  width: auto;
  flex-shrink: 0;
  border-radius: 20px;
  border: 1.4px solid #ececec;
}

.heading-value-text {
  color: #24b7aa;
}

.sales-chart-card.MuiPaper-root.MuiCard-root {
  height: auto;
  width: auto;
  flex-shrink: 0;
  border-radius: 20px;
  border: 1.4px solid #ececec;
}

.sales-chart-header{
    color: var(--text-high, rgba(1, 1, 2, 0.72));
    font-family: "Poppins";
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: -0.012em;
    text-align: left;
}

.sales-chart-body{
    color: var(--text-high, rgba(1, 1, 2, 0.72));
    font-family: "Poppins";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.012em;
    text-align: left;
}

.dropdown-hard-div.MuiInputBase-root.MuiOutlinedInput-root.MuiSelect-root{

}

`, "",{"version":3,"sources":["webpack://./src/components/css/successChart.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;IACI,4CAA4C;IAC5C,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;;AAEA","sourcesContent":[".success-chart-title {\n  color: #2d2d2d;\n  font-size: 16px;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.5px;\n}\n\n.success-chart-card.MuiPaper-root.MuiCard-root {\n  height: auto;\n  width: auto;\n  flex-shrink: 0;\n  border-radius: 20px;\n  border: 1.4px solid #ececec;\n}\n\n.heading-value-text {\n  color: #24b7aa;\n}\n\n.sales-chart-card.MuiPaper-root.MuiCard-root {\n  height: auto;\n  width: auto;\n  flex-shrink: 0;\n  border-radius: 20px;\n  border: 1.4px solid #ececec;\n}\n\n.sales-chart-header{\n    color: var(--text-high, rgba(1, 1, 2, 0.72));\n    font-family: \"Poppins\";\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 28px;\n    letter-spacing: -0.012em;\n    text-align: left;\n}\n\n.sales-chart-body{\n    color: var(--text-high, rgba(1, 1, 2, 0.72));\n    font-family: \"Poppins\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n    letter-spacing: -0.012em;\n    text-align: left;\n}\n\n.dropdown-hard-div.MuiInputBase-root.MuiOutlinedInput-root.MuiSelect-root{\n\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
